/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDate } from '../../models/local-date';
import { TerytUlicTo } from '../../models/teryt-ulic-to';

export interface ApiWebTerytMiejscaSimcUliceUlicGet$Params {
  simc: string;
  ulic: string;
  date?: LocalDate;
}

export function apiWebTerytMiejscaSimcUliceUlicGet(http: HttpClient, rootUrl: string, params: ApiWebTerytMiejscaSimcUliceUlicGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TerytUlicTo>> {
  const rb = new RequestBuilder(rootUrl, apiWebTerytMiejscaSimcUliceUlicGet.PATH, 'get');
  if (params) {
    rb.path('simc', params.simc, {});
    rb.path('ulic', params.ulic, {});
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TerytUlicTo>;
    })
  );
}

apiWebTerytMiejscaSimcUliceUlicGet.PATH = '/api/web/teryt/miejsca/{simc}/ulice/{ulic}';
